module.exports = __webpack_public_path__ + "media/hero-portrait.6330ba9e.mp4";